<template>
<v-container fluid>
    <v-card class="ma-2" outlined>
        <v-card-title>
            <v-btn icon @click="goToUserList">
                <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            {{ title }}
            <v-spacer></v-spacer>
        </v-card-title>

        <!-- Dialog for confirm update user -->
        <v-dialog v-model="dialog" max-width="400px">
            <v-card>
                <v-card-title class="text">Done!</v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="goToUserList">OK</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- prepare form data -->
        <v-form ref="form" lazy-validation v-model="valid" class="ma-5 pa-5">
            <v-row justify="end">
                <v-autocomplete :disabled="this.user_id ? true : false" v-model="select" :rules="requiredRule" :loading="loading" :items="userList" :search-input.sync="search" no-filter clearable return-object label="User" placeholder="ค้นหาชื่อ" required />
            </v-row>
            <v-row>
                <v-select v-model="editedItem.role" :items="roleList" :rules="requiredRule" label="เลือก Role" required></v-select>
            </v-row>
            <v-row>
                <v-combobox
                    v-model="editedItem.permissions"
                    :items="permissionsList"
                    label="Permissions"
                    multiple
                    ></v-combobox>
            </v-row>
            <v-row>
                <v-combobox
                    v-model="editedItem.orgInfo"
                    :items="orgList"
                    clearable
                    label="ใส่ชื่อหน่วยงาน"
                    ></v-combobox>
            </v-row>
            <v-row justify="end">
                <v-btn color="blue darken-1" text @click="goToUserList"> Cancel </v-btn>
                <v-btn v-if="this.user_id ? true : false" color="blue darken-1" text @click="submit">
                    Update
                </v-btn>
                <v-btn v-else color="blue darken-1" text @click="submit">
                    Add
                </v-btn>
            </v-row>
        </v-form>
    </v-card>
</v-container>
</template>

<script>
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import {
    mapGetters
} from "vuex";
import formatData from "../utils/formatData";
import getUserInfoByUserId from "../data/getUserInfoByUserId";
import setUserInfo from "../data/setUserInfo";
import getUserList from "../data/getUserList";
import getOrgList from "../data/getOrgList";
import setOrgInfo from "../data/setOrgInfo";
import getOrgInfoById from "../data/getOrgInfoById";
export default {
    name: 'ChallengeAdminForm',
    metaInfo: {
        title: 'Challenge Admin Form'
    },
    data() {
        return {
            select: null,
            search: null,
            loading: false,
            userList: [],
            orgList: [],
            editedItem: {
                name: "",
                role: "",
                permissions: [],
                orgInfo: {},
                uid: "",
            },
            defaultItem: {
                name: "",
                role: "",
                permissions: [],
                orgInfo: {},
                uid: "",
            },
            roleList: [{
                    value: "challengeAdmin",
                    text: "Admin"
                },
                {
                    value: "superAdmin",
                    text: "Super Admin"
                }
            ],
            permissionsList: [
                {
                    value: "accessQuiz",
                    text: "Access Quiz",
                },
                {
                    value: "accessOnlineSurvey",
                    text: "Access Online Survey",
                },
                {
                    value: "accessCoachAdmin",
                    text: "Access Coach",
                },
                {
                    value: "accessOrgAdmin",
                    text: "Access Org",
                },
                {
                    value: "accessPILMAdmin",
                    text: "Access PILM Admin",
                },
                {
                    value: "accessRewardProduct",
                    text: "Access Reward Products Management",
                },
                {
                    value: "downloadThaisookWatch",
                    text: "Download ThaisookWatch",
                }
            ],
            dialog: false,
            title: "Add",

            valid: false,
            requiredRule: [
                v => !!v
            ],
            adminListResult: [],
            orgTextList: []
        };
    },

    created() {
        var vm = this;
        vm.$store.state.appTitle = "Thaisook Web Admin | Challenge";
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                vm.$store.dispatch("autoSignIn", user);
                this.loading = true;
                setTimeout(() => {
                    vm.initialize();
                }, "1000");
            } else {
                console.log("no user");
            }
        });

        this.user_id = this.$route.params.user_id;
    },
    computed: {
        ...mapGetters([
            "loggedInUserId",
            "isAuthenticated",
            "isSuperAdmin",
            "isChallengeAdmin",
        ]),
    },
    watch: {
        dialog(val) {
            val || this.close();
        },
        select(value) {
            this.$emit("input", value ? value.value : null);
        },
        search(query) {
            if (query && (!this.select || this.select.text !== query)) {
                this.querySearch(query);
            } else {
                if (this.select != null) {
                    this.preload(this.select.value);
                } else {
                    this.userList = [];
                }
            }
        },
    },
    methods: {
        initialize() {
            if (this.isSuperAdmin) {
                if (this.user_id) {
                    this.preload(this.user_id);
                }
                else{
                    (async () => {
                        this.adminListResult = await getUserList("getAdminUser");
                        var orgList = await getOrgList();
                        orgList.forEach((v) => {
                            if( v.name != undefined ){
                                this.orgList.push({
                                    value: v.id,
                                    text: v.name
                                });
                                this.orgTextList.push( v.name ) 
                            }
                        });
                    })();
                }
                this.loading = false;
            } else {
                this.$router.push(`/dashboard`);
            }
        },
        preload(uid) {
            (async () => {
                if (uid) {
                    this.loading = true;
                    
                    this.editedItem = await getUserInfoByUserId(uid);
                    if (this.$route.name != 'Admin Add') {
                        this.title = 'Edit';
                    }
                    this.select = {
                        value: uid,
                        text: this.editedItem.name
                    };
                    this.userList = [this.select];
                    this.loading = false;

                    //set page title
                    const editPermissions = [];
                    if (this.editedItem.permissions != undefined && this.editedItem.permissions.length) {
                        let permissionHash = [];
                        if( this.permissionsList.length ){
                            this.permissionsList.forEach((v) => {
                                permissionHash[v.value] = v.text;
                            });
                        }
                        this.editedItem.permissions.forEach((v) => {
                            if( permissionHash[v] != undefined ){
                                editPermissions.push({
                                    'value': v,
                                    'text': permissionHash[v]
                                });
                            }
                        });
                        this.editedItem.permissions = editPermissions;
                    }
                    const orgInfo = await getOrgInfoById(this.editedItem.orgId);
                    this.editedItem.orgInfo = {
                        'value': orgInfo.id,
                        'text': orgInfo.name
                    };

                    this.adminListResult = await getUserList("getAdminUser");
                    var orgList = await getOrgList();
                    orgList.forEach((v) => {
                        if( v.name != undefined ){
                            this.orgList.push({
                                value: v.id,
                                text: v.name
                            });
                            this.orgTextList.push( v.name ) 
                        }
                    });
                }
                else{
                    this.loading = false;
                }
            })();
        },
        submit() {
            (async () => {
                await this.$refs.form.validate();
                if (this.valid) {
                    const permissionsSelected = [];
                    if (this.editedItem.permissions != undefined && this.editedItem.permissions.length) {
                        this.editedItem.permissions.forEach((item) => {
                            permissionsSelected.push(item.value);
                        });
                    }
                    (async () => {
                        //TO add new org if not exist
                        if( typeof this.editedItem.orgInfo == 'string' ){
                            if( !this.orgTextList.includes(this.editedItem.orgInfo) ){
                                const newOrgId = await setOrgInfo({
                                    name: this.editedItem.orgInfo,
                                    createdDate: new Date(),
                                    createdBy: this.loggedInUserId,
                                    updatedDate: new Date(),
                                    updatedBy: this.loggedInUserId
                                });
                                this.editedItem.orgInfo = {
                                    value: newOrgId,
                                    text: this.editedItem.orgInfo
                                };
                            }
                        }
                        
                        await setUserInfo(this.editedItem.uid, {
                            role: this.editedItem.role,
                            orgId: this.editedItem.orgInfo.value,
                            org: this.editedItem.orgInfo.text,
                            permissions: permissionsSelected
                        });
                        this.dialog = true;
                    })();
                }
            })();
        },
        close() {
            this.dialog = false;
        },
        querySearch(query) {
            (async () => {
                if (query) {
                    const userListResult = await getUserList("filter", query, this.adminListResult);
                    const userArray = [];
                    userListResult.forEach((user) => {
                        let displayText = user.phoneNumber ? user.phoneNumber : user.email;
                        if(displayText.startsWith('line-')){
                            displayText = 'Line';
                        }
                        userArray.push({
                            value: user.uid,
                            text: user.name + " (" + displayText + ")"
                        });
                    });
                    this.userList = userArray;
                }
            })();
        },
        _formatData(type, value) {
            return formatData(type, value);
        },
        goToUserList() {
            this.$router.push(`/user`);
        },
        goToAddAdmin() {
            this.$router.push(`/user/add`);
        },
    },
};
</script>
